import React from 'react'
import { SyntaxHighlightedCode } from '../../components/SyntaxHighlightedCode'
import { useCustomFieldCatalog } from './useCustomFieldCatalog'
import { customFieldKeyspaceForAdType } from './types'

export const CustomFieldTriggerCode = ({
    code,
    adType,
    profileId,
    className = '',
}: {
    code: string
    adType: number | string
    profileId: string | null
    className?: string
}) => {
    const entityType = customFieldKeyspaceForAdType(adType)
    const { editorContext } = useCustomFieldCatalog(profileId, entityType)
    return (
        <SyntaxHighlightedCode
            code={code}
            version={2}
            className={className}
            customFieldContext={editorContext}
        />
    )
}
